import styled from 'styled-components';

export const Container = styled.div`
  & > div {
    display: flex;
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.grayDark};

    &:not(:last-child) {
      padding-bottom: 0.5rem;
    }

    & > div {
      display: flex;
      align-items: center;
      width: 12rem;

      & > span:first-child {
        width: 0.875rem;
        height: 0.875rem;
        box-shadow: ${({ theme }) => theme.commoms.boxShadow};
        border-radius: 3px;
        margin-right: 0.5rem;

        &.pending {
          background-color: ${({ theme }) => theme.colors.chipPending};
        }
        &.delivery {
          background-color: ${({ theme }) => theme.colors.chipDelivery};
        }
        &.shipment {
          background-color: ${({ theme }) => theme.colors.chipShipment};
        }
        &.billed {
          background-color: ${({ theme }) => theme.colors.chipbBilled};
        }
        &.cancelled {
          background-color: ${({ theme }) => theme.colors.chipCancelled};
        }
      }
    }
  }
`;
